module.exports = __webpack_public_path__ + "img/certificate_popup_bg.01600478.png";